/**
 * Pilot signup URLs for the marketing site.
 *
 * Default (no client env): same-origin `/api/pilot-signup` and `/api/pilot-verify`.
 * Vercel sets server-side `SIGNUP_BACKEND_ORIGIN` so those routes proxy to your DeskReplay API.
 * You do not need `VITE_DESKREPLAY_API_ORIGIN` on the hosted marketing site for that path.
 *
 * Optional `VITE_DESKREPLAY_API_ORIGIN`: send requests straight to the API from the browser
 * (useful for local dev against localhost:8088, or when the admin session cookie must be
 * issued on the API host because marketing and admin run on different registrable domains).
 */
export function deskreplayApiOrigin(): string {
  const v = import.meta.env.VITE_DESKREPLAY_API_ORIGIN;
  if (typeof v !== "string") return "";
  return v.trim().replace(/\/$/, "");
}

/** Request OTP: proxy `/api/pilot-signup` when no direct API origin is configured. */
export function signupRequestUrl(): string {
  const o = deskreplayApiOrigin();
  return o ? `${o}/admin/signup/request` : "/api/pilot-signup";
}

/** Verify OTP + password: proxy `/api/pilot-verify` when no direct API origin is configured. */
export function signupVerifyUrl(): string {
  const o = deskreplayApiOrigin();
  return o ? `${o}/admin/signup/verify-otp` : "/api/pilot-verify";
}

export function adminLandingUrl(): string {
  const v = import.meta.env.VITE_ADMIN_URL;
  if (typeof v === "string" && v.trim()) return v.trim().replace(/\/$/, "");
  const o = deskreplayApiOrigin();
  return o || "https://live.deskreplay.com";
}
